angular.module('gym.reports', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.reports', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.reports.list', {
    url: '/reports?tags&tab',
    template: require('templates/gyms/reports/index.html.slim'),
    reloadOnSearch: false
  }).state('gym.reports.new', {
    url: '/reports/new',
    controller: 'EditReportCtrl',
    template: require('templates/gyms/reports/edit.html.slim'),
    resolve: {
      report: ["Reports", function(Reports) {
        return Reports.get('new');
      }],
      reports: ["Reports", "gym", function(Reports, gym) {
        if (gym.attributes.gym_config.can_use_in_other_report_filters) {
          return Reports.getList({
            count: 1000
          });
        } else {
          return [];
        }
      }],
      title: function() {
        return 'New Report';
      }
    }
  }).state('gym.reports.show', {
    url: '/reports/:reportId',
    controller: 'ShowReportCtrl',
    template: require('templates/gyms/reports/show.html.slim'),
    resolve: {
      report: ["Reports", "$stateParams", function(Reports, $stateParams) {
        return Reports.get($stateParams.reportId, {
          page: 1,
          count: 10
        });
      }],
      reports: ["Reports", "report", function(Reports, report) {
        var hasInReportFilter;
        hasInReportFilter = _.find(report.report_filters_attributes, function(filter) {
          var inSubFilter, ref;
          inSubFilter = _.find(filter.report_sub_filters_attributes, function(subfilter) {
            var ref;
            return (ref = subfilter.operator) === 'IN REPORT' || ref === 'NOT IN REPORT';
          });
          return ((ref = filter.operator) === 'IN REPORT' || ref === 'NOT IN REPORT') || inSubFilter;
        });
        if (hasInReportFilter) {
          return Reports.getList({
            count: 1000
          });
        } else {
          return [];
        }
      }]
    }
  }).state('gym.reports.edit', {
    url: '/reports/:reportId/edit',
    controller: 'EditReportCtrl',
    template: require('templates/gyms/reports/edit.html.slim'),
    resolve: {
      report: ["Reports", "$stateParams", function(Reports, $stateParams) {
        return Reports.oneUrl(`${$stateParams.reportId}/edit`).get();
      }],
      reports: ["$stateParams", "Reports", "gym", function($stateParams, Reports, gym) {
        if (gym.attributes.gym_config.can_use_in_other_report_filters) {
          return Reports.getList({
            count: 1000
          }).then(function(reports) {
            return reports.filter(function(item) {
              return item.id !== +$stateParams.reportId;
            });
          });
        } else {
          return [];
        }
      }],
      title: function() {
        return 'Edit Report';
      }
    }
  }).state('gym.reports.log_entries', {
    url: '/reports/:reportId/report_log_entries',
    controller: 'ReportLogEntriesCtrl',
    template: require('templates/gyms/reports/log_entries.html.slim'),
    resolve: {
      report: ["Reports", "$stateParams", function(Reports, $stateParams) {
        return Reports.get($stateParams.reportId);
      }],
      logEntries: ["report", function(report) {
        return report.all('report_log_entries').getList();
      }]
    }
  }).state('gym.reports.debtors', {
    url: '/debtors',
    template: require('templates/gyms/reports/financial/debtors.html.slim')
  }).state('gym.reports.daily_takings', {
    url: '/financial_reports/daily_takings',
    template: require('templates/gyms/reports/financial/daily_takings.html.slim')
  }).state('gym.reports.all_attendance', {
    url: '/attendance_reports/all_attendances',
    template: require('templates/gyms/reports/attendance/all_attendance.html.slim')
  }).state('gym.reports.general_kiosk_attendances', {
    url: '/general_kiosk_attendances',
    template: require('templates/gyms/reports/attendance/general_kiosk_attendances.html.slim')
  }).state('gym.reports.contact_attendance', {
    url: '/attendance_reports/contact_attendances',
    template: require('templates/gyms/reports/attendance/contact_attendance.html.slim')
  }).state('gym.reports.attendance_notes', {
    url: '/attendance_reports/attendance_notes',
    template: require('templates/gyms/reports/attendance/attendance_notes.html.slim')
  }).state('gym.reports.hiit_attendance', {
    url: '/attendance_reports/hiit_attendance',
    template: require('templates/gyms/reports/attendance/hiit_attendance.html.slim')
  }).state('gym.reports.kiosk_checkin_alerts', {
    url: '/attendance_reports/kiosk_checkin_alerts',
    template: require('templates/gyms/reports/attendance/kiosk_checkin_alerts.html.slim')
  }).state('gym.reports.booking_cancellations', {
    url: '/booking_cancellations',
    template: require('templates/gyms/reports/attendance/booking_cancellations.html.slim')
  }).state('gym.reports.payrolls', {
    url: '/payrolls',
    template: require('templates/gyms/reports/attendance/payrolls.html.slim')
  }).state('gym.reports.payment_failures', {
    url: '/payment_failures',
    template: require('templates/gyms/reports/financial/payment_failures.html.slim')
  }).state('gym.reports.all_events', {
    url: '/combined_events',
    template: require('templates/gyms/reports/attendance/all_events.html.slim')
  }).state('gym.reports.recurring_booking_events', {
    url: '/calendar/recurring_booking_events',
    template: require('templates/gyms/reports/attendance/recurring_booking_events.html.slim')
  }).state('gym.reports.recurring_booking_summaries', {
    url: '/recurring_booking_summaries',
    template: require('templates/gyms/reports/attendance/recurring_booking_summaries.html.slim')
  }).state('gym.reports.bulk_delete_events', {
    url: '/bulk_delete_events/new',
    template: require('templates/gyms/reports/attendance/bulk_delete_events.html.slim')
  }).state('gym.reports.bulk_delete_makeup_classes', {
    url: '/bulk_delete_makeup_class_allowances/new',
    template: require('templates/gyms/reports/attendance/bulk_delete_makeup_classes.html.slim')
  }).state('gym.reports.sms_deliveries', {
    url: '/contact_reports/sms_deliveries',
    template: require('templates/gyms/reports/contact/sms_deliveries.html.slim')
  }).state('gym.reports.contact_notes', {
    url: '/contact_reports/notes',
    template: require('templates/gyms/reports/contact/contact_notes.html.slim')
  }).state('gym.reports.contact_flags', {
    url: '/contact_reports/flags',
    template: require('templates/gyms/reports/contact/contact_flags.html.slim')
  }).state('gym.reports.archived_memberships', {
    url: '/contact_reports/archived_memberships',
    template: require('templates/gyms/reports/contact/archived_memberships.html.slim')
  }).state('gym.reports.pending_cancellations', {
    url: '/contact_reports/pending_cancellations',
    template: require('templates/gyms/reports/contact/pending_cancellations.html.slim')
  }).state('gym.reports.mandates', {
    url: '/contact_reports/mandates',
    template: require('templates/gyms/reports/contact/mandates.html.slim')
  }).state('gym.reports.bulk_member_portal_operations', {
    url: '/member_portals/new',
    controller: 'BulkMemberPortalOperationsCtrl',
    template: require('templates/gyms/reports/contact/bulk_member_portal_operations.html.slim')
  }).state('gym.reports.bulk_mobile_app_changes', {
    url: '/mobile_app/bulk_contact_changes',
    template: require('templates/gyms/reports/contact/bulk_mobile_app_changes.html.slim')
  }).state('gym.reports.bulk_suspend_contacts', {
    url: '/bulk_suspensions/new',
    template: require('templates/gyms/reports/contact/bulk_suspend_contacts.html.slim')
  }).state('gym.reports.confirm_bulk_suspend_contacts', {
    url: '/bulk_suspensions/confirm',
    template: require('templates/gyms/reports/contact/confirm_bulk_suspend_contacts.html.slim')
  }).state('gym.reports.new_bulk_cancellation', {
    url: '/bulk_cancellations/new',
    template: require('templates/gyms/reports/contact/new_bulk_cancellation.html.slim')
  }).state('gym.reports.bulk_add_memberships', {
    url: '/bulk_add_memberships/new',
    template: require('templates/gyms/reports/contact/bulk_add_memberships.html.slim')
  }).state('gym.reports.email_verifications', {
    url: '/email_verifications',
    template: require('templates/gyms/reports/email_verification/email_verifications.html.slim')
  }).state('gym.reports.mobile_app_users', {
    url: '/mobile_app_users',
    template: require('templates/gyms/reports/contact/mobile_app_users.html.slim')
  }).state('gym.reports.enrolled_sequences', {
    url: '/enrolled_sequences',
    template: require('templates/gyms/reports/contact/enrolled_sequences.html.slim'),
    reloadOnSearch: false
  }).state('gym.reports.contact_us_form_submissions', {
    url: '/contact_us_form_submissions',
    template: require('templates/gyms/reports/contact/contact_us_form_submissions.html.slim')
  });
}]);
